import TransacaoNotaFiscal from "model/fiscal/TransacaoNotaFiscal";
import CondicaoPagamento from "model/fiscal/CondicaoPagamento";
import { ItemEmissaoNotaFiscalSaida } from "model/vendas/EmitirNotaFiscalSaida";

const arredondar = (valor: number) => Math.round((valor + Number.EPSILON) * 100) / 100;

export default class NotaFiscalSaidaCalculoService {
    calcularDiferimentoIcms(item: ItemEmissaoNotaFiscalSaida, transacao: TransacaoNotaFiscal | null) {
        if (item.cstIcms === "51" && item.informarCalculoIcms51 === false)
            return { operacao: 0, diferido: 0, devido: 0 };
        transacao = item.transacaoNotaFiscal ?? transacao;
        const valorProdutos = arredondar(item.quantidadeComercial * item.valorUnitario);
        const baseOriginal = valorProdutos - item.valorDesconto
            + (transacao?.incluiFreteBaseIcms ? item.valorFrete : 0)
            + (transacao?.incluiSeguroBaseIcms ? item.valorSeguro : 0)
            + (transacao?.incluiOutrasDespesasBaseIcms ? item.valorOutrasDespesas : 0)
            + (transacao?.incluiIpiBaseIcms ? this.calcularIpi(item, transacao) : 0);
        const base = arredondar(Math.max(0, baseOriginal) * (100 - (item.percentualReducaoBaseIcms ?? 0)) / 100);
        const operacao = arredondar(base * (item.aliquotaIcms ?? 0) / 100);
        const diferido = arredondar(operacao * (item.percentualDiferimentoIcms ?? 0) / 100);
        return { operacao, diferido, devido: arredondar(operacao - diferido) };
    }

    pagamentoAVista(condicao: CondicaoPagamento | null): boolean {
        const regras = condicao?.parcelas ?? [];
        return regras.length > 0 && regras.every(regra => regra.quantidadeParcelas === 1
            && regra.diasPrimeiroVencimento === 0 && regra.diaFixoMes == null);
    }

    calcularIpi(item: ItemEmissaoNotaFiscalSaida, transacao: TransacaoNotaFiscal | null): number {
        transacao = item.transacaoNotaFiscal ?? transacao;
        if (!(item.tributaIpi ?? transacao?.tributaIpi) || !["50", "99"].includes(item.cstIpi ?? "")) return 0;

        const valorProdutos = arredondar(item.quantidadeComercial * item.valorUnitario);
        let base = valorProdutos - item.valorDesconto
            + (transacao?.incluiFreteBaseIpi ? item.valorFrete : 0)
            + (transacao?.incluiSeguroBaseIpi ? item.valorSeguro : 0)
            + (transacao?.incluiOutrasDespesasBaseIpi ? item.valorOutrasDespesas : 0);
        if (item.percentualReducaoBaseIpi) {
            base = arredondar(base * (100 - item.percentualReducaoBaseIpi) / 100);
        }
        return arredondar(Math.max(0, base) * (item.aliquotaIpi ?? 0) / 100);
    }

    calcularTotalItem(item: ItemEmissaoNotaFiscalSaida, transacao: TransacaoNotaFiscal | null): number {
        const valorProdutos = arredondar(item.quantidadeComercial * item.valorUnitario);
        return arredondar(valorProdutos + item.valorFrete + item.valorSeguro
            + item.valorOutrasDespesas - item.valorDesconto + this.calcularIpi(item, transacao));
    }
}
